import { C } from '../data/constants.js';

export class Projectile {
  constructor(x, y) {
    this.x = x;
    this.y = y;
    this.w = 3;
    this.h = 10;
    this.speed = 6;  // pixels per physics tick (fast!)
    this.alive = true;
    this.damage = 1;
  }

  update() {
    this.y -= this.speed;
    
    // Off-screen (above top border)
    if (this.y + this.h < C.HUD_HEIGHT) {
      this.alive = false;
    }
  }

  // Check collision with a brick
  hitsBrick(brick) {
    if (!brick.alive) return false;
    return (
      this.x + this.w / 2 > brick.x &&
      this.x - this.w / 2 < brick.x + brick.w &&
      this.y < brick.y + brick.h &&
      this.y + this.h > brick.y
    );
  }

  render(ctx) {
    if (!this.alive) return;
    
    // Laser bolt glow
    ctx.shadowColor = '#4488ff';
    ctx.shadowBlur = 6;
    
    // Main bolt body
    ctx.fillStyle = '#88bbff';
    ctx.fillRect(this.x - this.w / 2, this.y, this.w, this.h);
    
    // Bright core
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(this.x - 0.5, this.y + 1, 1, this.h - 2);
    
    ctx.shadowBlur = 0;
  }
}
